import { Box } from '@99designs/emu';
import { FAQFormattedAnswer, QuestionAnswerProps } from '@99designs/marketing-ui';
import { FixedPriceProjectProductAdditionalDetail } from '../../types/Product';
import { contentfulRichText } from '../../util/contentfulRichText';
import type { Faq } from '../../types/Contentful';

export function formatFaqsFromAdditionalDetails(
    faqs: FixedPriceProjectProductAdditionalDetail[]
): QuestionAnswerProps[] {
    return faqs.map(({ title, description, ctaLink }, i) => ({
        id: `additional-cost${i}`,
        question: title,
        answer: (
            <Box paddingBottom="1.5bu" as="p">
                <FAQFormattedAnswer
                    answer={__(description)}
                    linksReplacements={{ Link: ctaLink || '' }}
                />
            </Box>
        ),
    }));
}

export function formatFaqsFromContentful(faqs: Faq[]): QuestionAnswerProps[] {
    return faqs.map((faq: Faq, i: number) => ({
        id: `faq${i}`,
        question: faq.fields.question,
        answer: (
            <Box
                paddingBottom="1.5bu"
                maxWidth={['fit-content', 'fit-content', '720px', '720px']}
                as="div"
            >
                {contentfulRichText(faq.fields.answer)}
            </Box>
        ),
    }));
}
